var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tips)+"%")]),_c('Echart',{attrs:{"options":_vm.options,"id":_vm.id,"height":"100%","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }